import React, { useState } from 'react'

import { View, StyleSheet } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { useContent } from '@sart/content'
import client, { useClient } from '@sart/client'

import { Description, Space, MenuList, Text } from '@sart/components'
import { adaptive, typography, colors } from '@sart/styles'
import {
  User,
  Mobile
} from '@sart/icons'
import { testID } from '@sart/utilities'

export default function Profile(props) {
  const { navigation } = props

  const content = useContent()
  const {
    cache: {
      customer,
      accounts
    } = {}
  } = useClient()
  
  const menuItems = [
    {id: 'Account', label: content.profile.accountLabel, },
    {id: 'Settings', label: content.profile.settingsLabel, },
    {id: 'Switch', label: content.profile.switchLabel, }
  ]

  const emailLength = customer && customer.personalDetails && customer.personalDetails.emailAddress.length

  return (
    <View style={styles.container}>
        <MenuList color={colors.srGreen}>
          {
            menuItems.map(item =>
              <MenuList.Item
                key={item.id}
                label={item.label}
                onPress={() => navigation.navigate(item.id)}
                style={styles.menuitem}
                {...testID(item.id)}
              />
            )
          }
        </MenuList>

    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingBottom: 64,
    ...adaptive.wrapperPadding,
    justifyContent: 'center',
  },
  menuitem: {
    color: colors.srTextInput,
    ...typography.lightbold
  },
  number: {
    flexDirection: 'row',
    alignItems: 'center'
  }
})